<template>
  <div class="row">
    <div class="col-lg-4 col-md-6 mx-auto mt-5">
      <div id="formContent">
        <div class="card rounded shadow shadow-sm">
          <div class="card-header">
            <h4 class="mb-0">
              <icon :data="signIn" width="36" height="36" dir="up" />
            </h4>
            <ServerErrorMessage :error-data="errorData" />
          </div>
          <div class="card-body">
            <Form @submit="onSubmit" :validation-schema="schema">
              <TextInput
                name="email"
                type="email"
                label="E-mail"
                placeholder="Your email address"
              />
              <TextInput
                name="password"
                type="password"
                label="Password"
                placeholder="Your password"
                autocomplete="off"
              />
              <button class="fabric-btn fabric-btn-submit">Login</button>
            </Form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as Yup from "yup";
import ServerErrorMessage from "@/components/notification/ServerErrorMessage";
import { mapActions, mapMutations, mapGetters } from "vuex";
import signIn from "@fa/solid/sign-in-alt.svg";

export default {
  name: "Login",
  data: () => ({
    errorData: null,
    signIn
  }),
  components: {
    ServerErrorMessage
  },
  setup() {
    const schema = Yup.object().shape({
      email: Yup.string()
        .email()
        .required(),
      password: Yup.string()
        .min(6)
        .required(),
    });
    return {
      schema
    };
  },
  computed: {
    ...mapGetters(["getLoading"])
  },
  methods: {
    ...mapMutations(["setLoading", "setUser"]),
    ...mapActions([
      "handleLogin",
      "loginSuccess",
      "fetchProviderList",
      "getLoggedInUser"
    ]),
    async onSubmit(params) {
      let data = {
        client_id: params.email,
        client_secret: params.password
      };
      this.setLoading({ bool: true });
      const response = await this.handleLogin(data).catch(err => {
        this.setLoading({ bool: false });
        if (err.response) {
          this.errorData = err.response.data;
        } else {
          this.errorData = err.message;
        }
      });

      if (response) {
        await this.loginSuccess(response).catch(err => console.log(err));
        await this.getLoggedInUser().catch(err => console.log(err));
        // this.fetchProviderList().catch(err => console.log(err));

        setTimeout(() => {
          const params = new Proxy(
            new URLSearchParams(window.location.search),
            {
              get: (searchParams, prop) => searchParams.get(prop)
            }
          );
          if (params.url !== null) {
            window.location = params.url;
          } else {
            this.$router.push({ name: "Home" });
          }
        }, 2000);
      }
    }
  },
  unmounted() {
    this.setLoading({ bool: false });
  }
};
</script>
<style lang="scss">
* {
  box-sizing: border-box;
}

.fabric-btn-submit:hover {
  transform: scale(1.1);
}

.v-icon,
.custom-icon {
  width: 24px;
}
</style>
